"use client";

const VideoSection = () => {
  return (
    <div className="flex flex-col gap-6 md:gap-8 md:-mr-10">
      {/* Video Box */}
      <div className="relative w-full overflow-hidden rounded-xl border-2 border-gray-300">
        <div className="relative pt-[60%]"> 
          {/* 15:9 Aspect Ratio → (9/15 = 60%) */}
          <video
            controls
            className="absolute inset-0 w-full h-full rounded-xl"
            poster="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mP8/wcAAtEBhgc2nlIAAAAASUVORK5CYII="
          >
            <source src="/assets/Demovideo(1).mp4#t=1" type="video/mp4" />
            Your browser does not support the video tag.
          </video>
        </div>
      </div>

      {/* Title */}
      <div className="text-center">
        <p className="text-blue-600 text-lg md:text-xl font-medium">
          Carer Lab Video
        </p>
      </div>
    </div>
  );
};

export default VideoSection;
